//Login Actions
export const LOGIN_INITIAL = "LOGIN_INITIAL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
// Candidate List
export const CANDIDATE_INITIAL = "CANDIDATE_INITIAL";
export const CANDIDATE_SUCCESS = "CANDIDATE_SUCCESS";
export const CANDIDATE_FAIL = "CANDIDATE_FAIL";
// Schedule API
export const SCHEDULE_INITIAL = "SCHEDULE_INITIAL";
export const SCHEDULE_SUCCESS = "SCHEDULE_SUCCESS";
export const SCHEDULE_FAIL = "SCHEDULE_FAIL";
export const SCHEDULE_EXT_ERROR = "SCHEDULE_EXT_ERROR";
//Login Actions
export const VERIFY_EMAIL_INITIAL = "VERIFY_EMAIL_INITIAL";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAIL = "VERIFY_EMAIL_FAIL";
export const VERIFY_EMAIL_NETWORK_ERROR = "VERIFY_EMAIL_NETWORK_ERROR";

//Verify Interviewer Actions
export const VERIFY_INTERVIEWER_EMAIL_INITIAL =
  "VERIFY_INTERVIEWER_EMAIL_INITIAL";
export const VERIFY_INTERVIEWER_EMAIL_SUCCESS =
  "VERIFY_INTERVIEWER_EMAIL_SUCCESS";
export const VERIFY_INTERVIEWER_EMAIL_FAIL = "VERIFY_INTERVIEWER_EMAIL_FAIL";

//My Profile Actions
export const MYPROFILE_INITIAL = "MYPROFILE_INITIAL";
export const MYPROFILE_SUCCESS = "MYPROFILE_SUCCESS";
export const MYPROFILE_FAIL = "MYPROFILE_FAIL";
export const MYPROFILE_SERVER_ERROR = "MYPROFILE_SERVER_ERROR";

//Update My Profile Actions
export const UPDATE_MYPROFILE_INITIAL = "UPDATE_MYPROFILE_INITIAL";
export const UPDATE_MYPROFILE_SUCCESS = "UPDATE_MYPROFILE_SUCCESS";
export const UPDATE_MYPROFILE_FAIL = "UPDATE_MYPROFILE_FAIL";

//Sign Up Actions
export const SIGNUP_INITIAL = "SIGNUP_INITIAL";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const SIGNUP_EXT_ERROR = "SIGNUP_EXT_ERROR";

//Resend SignUp Email Actions
export const RESEND_SIGNUP_EMAIL_INITIAL = "RESEND_SIGNUP_EMAIL_INITIAL";
export const RESEND_SIGNUP_EMAIL_SUCCESS = "RESEND_SIGNUP_EMAIL_SUCCESS";
export const RESEND_SIGNUP_EMAIL_FAIL = "RESEND_SIGNUP_EMAIL_FAIL";

//Upload Company Logo Actions
export const COMPANY_LOGO_UPLOAD_SUCCESS = "COMPANY_LOGO_UPLOAD_SUCCESS";
export const COMPANY_LOGO_UPLOAD_FAIL = "COMPANY_LOGO_UPLOAD_FAIL";

//Get Country Listing My Profile Page Atishay
export const GET_COUNTRY_INITIAL = "GET_COUNTRY_INITIAL";
export const GET_COUNTRY_SUCCESS = "GET_COUNTRY_SUCCESS";
export const GET_COUNTRY_FAIL = "GET_COUNTRY_FAIL";

//Get STATE Listing My Profile Page Atishay
export const GET_STATE_INITIAL = "GET_STATE_INITIAL";
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_FAIL = "GET_STATE_FAIL";

//Get CITY Listing My Profile Page Atishay
export const GET_CITY_INITIAL = "GET_CITY_INITIAL";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_FAIL = "GET_CITY_FAIL";

// Email Link for Password Reset Actions
export const FORGOT_PASSWORD_LINK_INITIAL = "FORGOT_PASSWORD_LINK_INITIAL";
export const FORGOT_PASSWORD_LINK_SUCCESS = "FORGOT_PASSWORD_LINK_SUCCESS";
export const FORGOT_PASSWORD_LINK_FAIL = "FORGOT_PASSWORD_LINK_FAILL";
export const FORGOT_PASSWORD_NETWORK_ERROR = "FORGOT_PASSWORD_NETWORK_ERROR";
export const FORGOT_PASSWORD_SECOND_SCREEN_HIDE =
  "FORGOT_PASSWORD_SECOND_SCREEN_HIDE";
// For removing Forgot Password Second Screen(coming on click of Forgot Password)

// Reset password field after clicked on link
export const RESET_PASSWORD_INITIAL = "RESET_PASSWORD_INITIAL";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

//Update Company Location on My Profile Page
export const UPDATE_COMPANY_LOCATION_INITIAL =
  "UPDATE_COMPANY_LOCATION_INITIAL";
export const UPDATE_COMPANY_LOCATION_SUCCESS =
  "UPDATE_COMPANY_LOCATION_SUCCESS";
export const UPDATE_COMPANY_LOCATION_FAIL = "UPDATE_COMPANY_LOCATION_FAIL";

//Verify OTP by clicking Verify button
export const VERIFY_OTP_INITIAL = "VERIFY_OTP_INITIAL";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAIL = "VERIFY_OTP_FAIL";
export const VERIFY_OTP_NETWORK_ERROR = "VERIFY_OTP_NETWORK_ERROR";
export const VERIFY_OTP_RESET_STATE = "VERIFY_OTP_RESET_STATE";

//getInterviewList on Interview page (scheduleInterviewer.jsx)

export const GETINTERVIEWLIST_INITIAL = "GETINTERVIEWLIST_INITIAL";
export const GETINTERVIEWLIST_SUCCESS = "GETINTERVIEWLIST_SUCCESS";
export const GETINTERVIEWLIST_FAIL = "GETINTERVIEWLIST_FAIL";
export const GETINTERVIEWLIST_NETWORK_ERROR = "GETINTERVIEWLIST_NETWORK_ERROR";

//View Job Profile listing on Job Profile
export const VIEW_JOB_PROFILE_INITIAL = "VIEW_JOB_PROFILE_INITIAL";
export const VIEW_JOB_PROFILE_SUCCESS = "VIEW_JOB_PROFILE_SUCCESS";
export const VIEW_JOB_PROFILE_FAIL = "VIEW_JOB_PROFILE_FAIL";

//Update Job Profile listing on Job Profile
export const UPDATE_JOB_PROFILE_INITIAL = "UPDATE_JOB_PROFILE_INITIAL";
export const UPDATE_JOB_PROFILE_SUCCESS = "UPDATE_JOB_PROFILE_SUCCESS";
export const UPDATE_JOB_PROFILE_FAIL = "UPDATE_JOB_PROFILE_FAIL";

//Archive Job Profile listing on Job Profile
export const ARCHIVE_JOB_PROFILE_INITIAL = "ARCHIVE_JOB_PROFILE_INITIAL";
export const ARCHIVE_JOB_PROFILE_SUCCESS = "ARCHIVE_JOB_PROFILE_SUCCESS";
export const ARCHIVE_JOB_PROFILE_FAIL = "ARCHIVE_JOB_PROFILE_FAIL";

//Create Job Profile listing on Job Profile
export const CREATE_JOB_PROFILE_INITIAL = "CREATE_JOB_PROFILE_INITIAL";
export const CREATE_JOB_PROFILE_SUCCESS = "CREATE_JOB_PROFILE_SUCCESS";
export const CREATE_JOB_PROFILE_FAIL = "CREATE_JOB_PROFILE_FAIL";

//Get Skills Master  listing on Job Profile
export const GET_SKILLS_INITIAL = "GET_SKILLS_INITIAL";
export const GET_SKILLS_SUCCESS = "GET_SKILLS_SUCCESS";
export const GET_SKILLS_FAIL = "GET_SKILLS_FAIL";

//getDashboardDetails at Home page

export const GETDASHBOARDDETAILS_INITIAL = "GETDASHBOARDDETAILS_INITIAL";
export const GETDASHBOARDDETAILS_SUCCESS = "GETDASHBOARDDETAILS_SUCCESS";
export const GETDASHBOARDDETAILS_FAIL = "GETDASHBOARDDETAILS_FAIL";
export const GETDASHBOARDDETAILS_NETWORK_ERROR =
  "GETDASHBOARDDETAILS_NETWORK_ERROR";
//Schedule Interview Job Profile Listing Atishay
export const GET_JOB_PROFILE_INITIAL = "GET_JOB_PROFILE_INITIAL";
export const GET_JOB_PROFILE_SUCCESS = "GET_JOB_PROFILE_SUCCESS";
export const GET_JOB_PROFILE_FAIL = "GET_JOB_PROFILE_FAIL";
export const GET_JOB_PROFILE_ERROR = "GET_JOB_PROFILE_ERROR";

//Schedule Interview Candidate Profile Listing Atishay
export const GET_CANDIDATE_PROFILE_INITIAL = "GET_CANDIDATE_PROFILE_INITIAL";
export const GET_CANDIDATE_PROFILE_SUCCESS = "GET_CANDIDATE_PROFILE_SUCCESS";
export const GET_CANDIDATE_PROFILE_FAIL = "GET_CANDIDATE_PROFILE_FAIL";
export const GET_CANDIDATE_PROFILE_ERROR = "GET_CANDIDATE_PROFILE_ERROR";

//Schedule Interview INTERVIEWER Profile Listing Atishay Khare
export const GET_INTERVIEWER_PROFILE_INITIAL =
  "GET_INTERVIEWER_PROFILE_INITIAL";
export const GET_INTERVIEWER_PROFILE_SUCCESS =
  "GET_INTERVIEWER_PROFILE_SUCCESS";
export const GET_INTERVIEWER_PROFILE_FAIL = "GET_INTERVIEWER_PROFILE_FAIL";
export const GET_INTERVIEWER_PROFILE_ERROR = "GET_INTERVIEWER_PROFILE_ERROR";
//View Single Job Profile listing on Job Profile
export const VIEW_SINGLE_JOB_PROFILE_INITIAL =
  "VIEW_SINGLE_JOB_PROFILE_INITIAL";
export const VIEW_SINGLE_JOB_PROFILE_SUCCESS =
  "VIEW_SINGLE_JOB_PROFILE_SUCCESS";
export const VIEW_SINGLE_JOB_PROFILE_FAIL = "VIEW_SINGLE_JOB_PROFILE_FAIL";

//Create Candidate Profile Actions
export const CREATE_CANDIDATE_INITIAL = "CREATE_CANDIDATE_INITIAL";
export const CREATE_CANDIDATE_SUCCESS = "CREATE_CANDIDATE_SUCCESS";
export const CREATE_CANDIDATE_FAIL = "CREATE_CANDIDATE_FAIL";

//View Candidate Profile
export const VIEW_CANDIDATE_PROFILE_INITIAL = "VIEW_CANDIDATE_PROFILE_INITIAL";
export const VIEW_CANDIDATE_PROFILE_SUCCESS = "VIEW_CANDIDATE_PROFILE_SUCCESS";
export const VIEW_CANDIDATE_PROFILE_FAIL = "VIEW_CANDIDATE_PROFILE_FAIL";

//Archive Candidate Profile listing on Candidate Profile
export const ARCHIVE_CANDIDATE_PROFILE_INITIAL =
  "ARCHIVE_CANDIDATE_PROFILE_INITIAL";
export const ARCHIVE_CANDIDATE_PROFILE_SUCCESS =
  "ARCHIVE_CANDIDATE_PROFILE_SUCCESS";
export const ARCHIVE_CANDIDATE_PROFILE_FAIL = "ARCHIVE_CANDIDATE_PROFILE_FAIL";

//View Single Candidate Profile listing on Job Profile
export const VIEW_SINGLE_CANDIDATE_PROFILE_INITIAL =
  "VIEW_SINGLE_CANDIDATE_PROFILE_INITIAL";
export const VIEW_SINGLE_CANDIDATE_PROFILE_SUCCESS =
  "VIEW_SINGLE_CANDIDATE_PROFILE_SUCCESS";
export const VIEW_SINGLE_CANDIDATE_PROFILE_FAIL =
  "VIEW_SINGLE_CANDIDATE_PROFILE_FAIL";

//Update Candidate Profile listing on Candidate Profile
export const UPDATE_CANDIDATE_PROFILE_INITIAL =
  "UPDATE_CANDIDATE_PROFILE_INITIAL";
export const UPDATE_CANDIDATE_PROFILE_SUCCESS =
  "UPDATE_CANDIDATE_PROFILE_SUCCESS";
export const UPDATE_CANDIDATE_PROFILE_FAIL = "UPDATE_CANDIDATE_PROFILE_FAIL";
export const UPDATE_CANDIDATE_PROFILE_NETWORK_ERROR =
  "UPDATE_CANDIDATE_PROFILE_NETWORK_ERROR";

//Search Job Profile listing on Job Profile
export const SEARCH_JOB_PROFILE_INITIAL = "SEARCH_JOB_PROFILE_INITIAL";
export const SEARCH_JOB_PROFILE_SUCCESS = "SEARCH_JOB_PROFILE_SUCCESS";
export const SEARCH_JOB_PROFILE_FAIL = "SEARCH_JOB_PROFILE_FAIL";
export const SEARCH_JOB_PROFILE_EMPTY = "SEARCH_JOB_PROFILE_EMPTY";

//getInterviewerList on External Interviewer page (scheduleInterviewer.jsx)

export const GET_EXT_INTERVIEWER_LIST_INITIAL =
  "GET_EXT_INTERVIEWER_LIST_INITIAL";
export const GET_EXT_INTERVIEWER_LIST_SUCCESS =
  "GET_EXT_INTERVIEWER_LIST_SUCCESS";
export const GET_EXT_INTERVIEWER_LIST_FAIL = "GET_EXT_INTERVIEWER_LIST_FAIL";
export const GET_EXT_INTERVIEWER_LIST_NETWORK_ERROR =
  "GET_EXT_INTERVIEWER_LIST_NETWORK_ERROR";

//Search Candidate Profile listing on Candidate Profile
export const SEARCH_CANDIDATE_PROFILE_INITIAL =
  "SEARCH_CANDIDATE_PROFILE_INITIAL";
export const SEARCH_CANDIDATE_PROFILE_SUCCESS =
  "SEARCH_CANDIDATE_PROFILE_SUCCESS";
export const SEARCH_CANDIDATE_PROFILE_FAIL = "SEARCH_CANDIDATE_PROFILE_FAIL";
export const SEARCH_CANDIDATE_PROFILE_EMPTY = "SEARCH_CANDIDATE_PROFILE_EMPTY";

//Schedule Interview step 4 Atishay
export const SCHEDULE_INTERVIEW_PROFILE_INITIAL =
  "SCHEDULE_INTERVIEW_PROFILE_INITIAL";
export const SCHEDULE_INTERVIEW_PROFILE_SUCCESS =
  "SCHEDULE_INTERVIEW_PROFILE_SUCCESS";
export const SCHEDULE_INTERVIEW_PROFILE_FAIL =
  "SCHEDULE_INTERVIEW_PROFILE_FAIL";
export const SCHEDULE_INTERVIEW_PROFILE_ERROR =
  "SCHEDULE_INTERVIEW_PROFILE_ERROR";
export const SCHEDULE_INTERVIEW_PROFILE_RESET_STATE =
  "SCHEDULE_INTERVIEW_PROFILE_RESET_STATE";
// Schedule Councelling
export const SCHEDULE_COUNCELLING_INITIAL = "SCHEDULE_COUNCELLING_INITIAL";
export const SCHEDULE_COUNCELLING_SUCCESS = "SCHEDULE_COUNCELLING_SUCCESS";
export const SCHEDULE_COUNCELLING_FAIL = "SCHEDULE_COUNCELLING_FAIL";
export const SCHEDULE_COUNCELLING_ERROR = "SCHEDULE_COUNCELLING_ERROR";
// Search Schedule Job Profule
export const SEARCH_SCHEDULE_JOB_PROFILE_INITIAL =
  "SEARCH_SCHEDULE_JOB_PROFILE_INITIAL";
export const SEARCH_SCHEDULE_JOB_PROFILE_SUCCESS =
  "SEARCH_SCHEDULE_JOB_PROFILE_SUCCESS";
export const SEARCH_SCHEDULE_JOB_PROFILE_FAIL =
  "SEARCH_SCHEDULE_JOB_PROFILE_FAIL";
export const SEARCH_SCHEDULE_JOB_PROFILE_NETWORK_ERROR =
  "SEARCH_SCHEDULE_JOB_PROFILE_NETWORK_ERROR";
export const SEARCH_SCHEDULE_JOB_PROFILE_EMPTY =
  "SEARCH_SCHEDULE_JOB_PROFILE_EMPTY";

//Search Schedule Candidate Profile
export const SEARCH_SCHEDULE_CANDIDATE_PROFILE_EMPTY =
  "SEARCH_SCHEDULE_CANDIDATE_PROFILE_EMPTY";

//getInterviewerProfile on External Interviewer page (interviewerProfileView.jsx)

export const GET_INTERVIEWER_PROFILE_BRIJESH_INITIAL =
  "GET_INTERVIEWER_PROFILE_BRIJESH_INITIAL";
export const GET_INTERVIEWER_PROFILE_BRIJESH_SUCCESS =
  "GET_INTERVIEWER_PROFILE_BRIJESH_SUCCESS";
export const GET_INTERVIEWER_PROFILE_BRIJESH_FAIL =
  "GET_INTERVIEWER_PROFILE_BRIJESH_FAIL";
export const GET_INTERVIEWER_PROFILE_BRIJESH_NETWORK_ERROR =
  "GET_INTERVIEWER_PROFILE_BRIJESH_NETWORK_ERROR";

//saveIterviewerRating on External Interviewer page (interviewerProfileView.jsx)

export const SAVE_INTERVIEWER_RATING_INITIAL =
  "SAVE_INTERVIEWER_RATING_INITIAL";
export const SAVE_INTERVIEWER_RATING_SUCCESS =
  "SAVE_INTERVIEWER_RATING_SUCCESS";
export const SAVE_INTERVIEWER_RATING_FAIL = "SAVE_INTERVIEWER_RATING_FAIL";
export const SAVE_INTERVIEWER_RATING_NETWORK_ERROR =
  "SAVE_INTERVIEWER_RATING_NETWORK_ERROR";

//Get Candidate Feedback  Nikhil
export const GET_CANDIDATE_FEEDBACK_INITIAL = "GET_CANDIDATE_FEEDBACK_INITIAL";
export const GET_CANDIDATE_FEEDBACK_SUCCESS = "GET_CANDIDATE_FEEDBACK_SUCCESS";
export const GET_CANDIDATE_FEEDBACK_FAIL = "GET_CANDIDATE_FEEDBACK_FAIL";
export const GET_CANDIDATE_FEEDBACK_ERROR_FALSE =
  "GET_CANDIDATE_FEEDBACK_ERROR_FALSE";

//Get Candidate Multiple Feedbacks  Nikhil
export const GET_CANDIDATE_MULTIPLE_FEEDBACKS_INITIAL =
  "GET_CANDIDATE_MULTIPLE_FEEDBACKS_INITIAL";
export const GET_CANDIDATE_MULTIPLE_FEEDBACKS_SUCCESS =
  "GET_CANDIDATE_MULTIPLE_FEEDBACKS_SUCCESS";
export const GET_CANDIDATE_MULTIPLE_FEEDBACKS_FAIL =
  "GET_CANDIDATE_MULTIPLE_FEEDBACKS_FAIL";
export const GET_CANDIDATE_MULTIPLE_FEEDBACKS_NETWORK_ERROR =
  "GET_CANDIDATE_MULTIPLE_FEEDBACKS_NETWORK_ERROR";

//saveIterviewerRating on External Interviewer page (interviewerProfileView.jsx)

export const OPEN_CV_INITIAL = "OPEN_CV_INITIAL";
export const OPEN_CV_SUCCESS = "OPEN_CV_SUCCESS";
export const OPEN_CV_FAIL = "OPEN_CV_FAIL";
export const OPEN_CV_NETWORK_ERROR = "OPEN_CV_NETWORK_ERROR";
//Candidate Download File  Nikhil
export const CANDIDATE_DOWNLOAD_FILE_INITIAL =
  "CANDIDATE_DOWNLOAD_FILE_INITIAL";
export const CANDIDATE_DOWNLOAD_FILE_SUCCESS =
  "CANDIDATE_DOWNLOAD_FILE_SUCCESS";
export const CANDIDATE_DOWNLOAD_FILE_FAIL = "CANDIDATE_DOWNLOAD_FILE_FAIL";

// interviewer forgot password

export const INTERVIEWER_FORGOT_PASSWORD_INITIAL =
  "INTERVIEWER_FORGOT_PASSWORD_INITIAL";
export const INTERVIEWER_FORGOT_PASSWORD_SUCCESS =
  "INTERVIEWER_FORGOT_PASSWORD_SUCCESS";
export const INTERVIEWER_FORGOT_PASSWORD_FAIL =
  "INTERVIEWER_FORGOT_PASSWORD_FAIL";
export const INTERVIEWER_FORGOT_PASSWORD_NETWORK_ERROR =
  "INTERVIEWER_FORGOT_PASSWORD_NETWORK_ERROR";

// Resend Otp from login brijesh

export const RESEND_OTP_INITIAL = "RESEND_OTP_INITIAL";
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_FAIL = "RESEND_OTP_FAIL";
export const RESEND_OTP_NETWORK_ERROR = "RESEND_OTP_NETWORK_ERROR";

//Verify Otp at login
export const VERIFY_OTP_AT_LOGIN_INITIAL = "VERIFY_OTP_AT_LOGIN_INITIAL";
export const VERIFY_OTP_AT_LOGIN_SUCCESS = "VERIFY_OTP_AT_LOGIN_SUCCESS";
export const VERIFY_OTP_AT_LOGIN_FAIL = "VERIFY_OTP_AT_LOGIN_FAIL";
export const VERIFY_OTP_AT_LOGIN_NETWORK_ERROR =
  "VERIFY_OTP_AT_LOGIN_NETWORK_ERROR";
export const CLEAR_LOGIN_STATE = "CLEAR_LOGIN_STATE";

//REsend interviewer email
export const RESEND_INTERVIEWER_EMAIL_INITIAL =
  "RESEND_INTERVIEWER_EMAIL_INITIAL";
export const RESEND_INTERVIEWER_EMAIL_SUCCESS =
  "RESEND_INTERVIEWER_EMAIL_SUCCESS";
export const RESEND_INTERVIEWER_EMAIL_FAIL = "RESEND_INTERVIEWER_EMAIL_FAIL";
export const RESEND_INTERVIEWER_EMAIL_NETWORK_ERROR =
  "RESEND_INTERVIEWER_EMAIL_NETWORK_ERROR";

//Payment Initiate Process
export const ADMIN_PAYMENT_INITIATE = "ADMIN_PAYMENT_INITIATE";
export const ADMIN_PAYMENT_SUCCESS = "ADMIN_PAYMENT_SUCCESS";
export const ADMIN_PAYMENT_FAIL = "ADMIN_PAYMENT_FAIL";
export const ADMIN_PAYMENT_NETWORK_ERROR = "ADMIN_PAYMENT_NETWORK_ERROR";

//Payment Interview List Admin
export const ADMIN_INTERVIEW_LIST_INITIATE = "ADMIN_INTERVIEW_LIST_INITIATE";
export const ADMIN_INTERVIEW_LIST_SUCCESS = "ADMIN_INTERVIEW_LIST_SUCCESS";
export const ADMIN_INTERVIEW_LIST_FAIL = "ADMIN_INTERVIEW_LIST_FAIL";
export const ADMIN_INTERVIEW_LIST_NETWORK_ERROR =
  "ADMIN_INTERVIEW_LIST_NETWORK_ERROR";

//Security Deposit Payment
export const SECURITY_DEPOSIT_PAYMENT_INITIATE =
  "SECURITY_DEPOSIT_PAYMENT_INITIATE";
export const SECURITY_DEPOSIT_PAYMENT_SUCCESS =
  "SECURITY_DEPOSIT_PAYMENT_SUCCESS";
export const SECURITY_DEPOSIT_PAYMENT_FAIL = "SECURITY_DEPOSIT_PAYMENT_FAIL";
export const SECURITY_DEPOSIT_PAYMENT_NETWORK_ERROR =
  "SECURITY_DEPOSIT_PAYMENT_NETWORK_ERROR";

// Employer Cancel Interview
export const EMPLOYER_CANCEL_INTERVIEW_INITIATE =
  "EMPLOYER_CANCEL_INTERVIEW_INITIATE";
export const EMPLOYER_CANCEL_INTERVIEW_SUCCESS =
  "EMPLOYER_CANCEL_INTERVIEW_SUCCESS";
export const EMPLOYER_CANCEL_INTERVIEW_FAIL = "EMPLOYER_CANCEL_INTERVIEW_FAIL";
export const EMPLOYER_CANCEL_INTERVIEW_NETWORK_ERROR =
  "EMPLOYER_CANCEL_INTERVIEW_NETWORK_ERROR";

//Make Payment Admin
export const MAKE_PAYMENT_INITIATE = "MAKE_PAYMENT_INITIATE";
export const MAKE_PAYMENT_SUCCESS = "MAKE_PAYMENT_SUCCESS";
export const MAKE_PAYMENT_FAIL = "MAKE_PAYMENT_FAIL";
export const MAKE_PAYMENT_NETWORK_ERROR = "MAKE_PAYMENT_NETWORK_ERROR";

//Check Interview Schedule Balance
export const CHECK_INTERVIEW_SCHEDULE_BALANCE_INITIATE =
  "CHECK_INTERVIEW_SCHEDULE_BALANCE_INITIATE";
export const CHECK_INTERVIEW_SCHEDULE_BALANCE_SUCCESS =
  "CHECK_INTERVIEW_SCHEDULE_BALANCE_SUCCESS";
export const CHECK_INTERVIEW_SCHEDULE_BALANCE_FAIL =
  "CHECK_INTERVIEW_SCHEDULE_BALANCE_FAIL";
export const CHECK_INTERVIEW_SCHEDULE_BALANCE_NETWORK_ERROR =
  "CHECK_INTERVIEW_SCHEDULE_BALANCE_NETWORK_ERROR";
//Payment Invoice List Atishay Start
export const PAYMENT_INVOICE_LIST_INITIATE = "PAYMENT_INVOICE_LIST_INITIATE";
export const PAYMENT_INVOICE_LIST_SUCCESS = "PAYMENT_INVOICE_LIST_SUCCESS";
export const PAYMENT_INVOICE_LIST_FAIL = "PAYMENT_INVOICE_LIST_FAIL";
export const PAYMENT_INVOICE_LIST_NETWORK_ERROR =
  "PAYMENT_INVOICE_LIST_NETWORK_ERROR";
//Payment Invoice List Atishay Ends

//GET_INTERVIEWLIST_FORPAYMENT_NONADMIN BRIJESH

export const GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_INITIATE =
  "GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_INITIATE";
export const GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_SUCCESS =
  "GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_SUCCESS";
export const GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_FAIL =
  "GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_FAIL";
export const GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_NETWORK_ERROR =
  "GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_NETWORK_ERROR";

//Confirm Payment Status Admin
export const CONFIRM_PAYMENT_STATUS_INITIATE =
  "CONFIRM_PAYMENT_STATUS_INITIATE";
export const CONFIRM_PAYMENT_STATUS_SUCCESS = "CONFIRM_PAYMENT_STATUS_SUCCESS";
export const CONFIRM_PAYMENT_STATUS_FAIL = "CONFIRM_PAYMENT_STATUS_FAIL";
export const CONFIRM_PAYMENT_STATUS_NETWORK_ERROR =
  "CONFIRM_PAYMENT_STATUS_NETWORK_ERROR";

//Payment Invoice DETAILS Atishay Start
export const PAYMENT_INVOICE_DETAILS_INITIATE =
  "PAYMENT_INVOICE_DETAILS_INITIATE";
export const PAYMENT_INVOICE_DETAILS_SUCCESS =
  "PAYMENT_INVOICE_DETAILS_SUCCESS";
export const PAYMENT_INVOICE_DETAILS_FAIL = "PAYMENT_INVOICE_DETAILS_FAIL";
export const PAYMENT_INVOICE_DETAILS_NETWORK_ERROR =
  "PAYMENT_INVOICE_DETAILS_NETWORK_ERROR";
//Payment Invoice DETAILS Atishay Ends

//Payment Invoice DETAILS Atishay Start
export const ORDER_HISTORY_INITIATE = "ORDER_HISTORY_INITIATE";
export const ORDER_HISTORY_SUCCESS = "ORDER_HISTORY_SUCCESS";
export const ORDER_HISTORY_FAIL = "ORDER_HISTORY_FAIL";
export const ORDER_HISTORY_NETWORK_ERROR = "ORDER_HISTORY_NETWORK_ERROR";
//Payment Invoice DETAILS Atishay Ends

//APPROVE_PAYMENT_BYNONADMIN_ BRIJESH

export const APPROVE_PAYMENT_BYNONADMIN_INITIATE =
  "APPROVE_PAYMENT_BYNONADMIN_INITIATE";
export const APPROVE_PAYMENT_BYNONADMIN_SUCCESS =
  "APPROVE_PAYMENT_BYNONADMIN_SUCCESS";
export const APPROVE_PAYMENT_BYNONADMIN_FAIL =
  "APPROVE_PAYMENT_BYNONADMIN_FAIL";
export const APPROVE_PAYMENT_BYNONADMIN_NETWORK_ERROR =
  "APPROVE_PAYMENT_BYNONADMIN_NETWORK_ERROR";

//GET_INVOICE_DETAILS_BEFORE_PAYMENT_BRIJESH

export const GET_INVOICE_DETAILS_BEFORE_PAYMENT_INITIATE =
  "GET_INVOICE_DETAILS_BEFORE_PAYMENT_INITIATE";
export const GET_INVOICE_DETAILS_BEFORE_PAYMENT_SUCCESS =
  "GET_INVOICE_DETAILS_BEFORE_PAYMENT_SUCCESS";
export const GET_INVOICE_DETAILS_BEFORE_PAYMENT_FAIL =
  "GET_INVOICE_DETAILS_BEFORE_PAYMENT_FAIL";
export const GET_INVOICE_DETAILS_BEFORE_PAYMENT_NETWORK_ERROR =
  "GET_INVOICE_DETAILS_BEFORE_PAYMENT_NETWORK_ERROR";

export const PAYMENT_INVOICE_DETAILS_RESET_STATE =
  "PAYMENT_INVOICE_DETAILS_RESET_STATE";

//GET_INTERVIEWER_AVAILABLE_SLOTS_ATISHAY

export const GET_INTERVIEWER_AVAILABLE_SLOTS_INITIATE =
  "GET_INTERVIEWER_AVAILABLE_SLOTS_INITIATE";
export const GET_INTERVIEWER_AVAILABLE_SLOTS_SUCCESS =
  "GET_INTERVIEWER_AVAILABLE_SLOTS_SUCCESS";
export const GET_INTERVIEWER_AVAILABLE_SLOTS_FAIL =
  "GET_INTERVIEWER_AVAILABLE_SLOTS_FAIL";
export const GET_INTERVIEWER_AVAILABLE_SLOTS_NETWORK_ERROR =
  "GET_INTERVIEWER_AVAILABLE_SLOTS_NETWORK_ERROR";

//save interviewer rating new at schedule interviewer

export const NEW_SAVE_INTERVIEWER_RATING_INITIATE =
  "NEW_SAVE_INTERVIEWER_RATING_INITIATE";
export const NEW_SAVE_INTERVIEWER_RATING_SUCCESS =
  "NEW_SAVE_INTERVIEWER_RATING_SUCCESS";
export const NEW_SAVE_INTERVIEWER_RATING_FAIL =
  "NEW_SAVE_INTERVIEWER_RATING_FAIL";
export const NEW_SAVE_INTERVIEWER_RATING_NETWORK_ERROR =
  "NEW_SAVE_INTERVIEWER_RATING_NETWORK_ERROR";

export const EMPLOYER_LOGED_RESET_PASSWORD_INITIAL =
  "EMPLOYER_LOGED_RESET_PASSWORD_INITIAL";
export const EMPLOYER_LOGED_RESET_PASSWORD_SUCCESS =
  "EMPLOYER_LOGED_RESET_PASSWORD_SUCCESS";
export const EMPLOYER_LOGED_RESET_PASSWORD_FAIL =
  "EMPLOYER_LOGED_RESET_PASSWORD_FAIL";

export const NOTIFY_FOXMATRIX_INITIATE = "NOTIFY_FOXMATRIX_INITIATE";
export const NOTIFY_FOXMATRIX_SUCCESS = "NOTIFY_FOXMATRIX_SUCCESS";
export const NOTIFY_FOXMATRIX_FAIL = "NOTIFY_FOXMATRIX_FAIL";
export const NOTIFY_FOXMATRIX_NETWORK_ERROR = "NOTIFY_FOXMATRIX_NETWORK_ERROR";

export const CLEAR_STATE_NOTIFY = "CLEAR_STATE_NOTIFY";

// view interview details Brijesh

export const VIEW_INTERVIEW_DETAILS_INITIATE =
  "VIEW_INTERVIEW_DETAILS_INITIATE";
export const VIEW_INTERVIEW_DETAILS_SUCCESS = "VIEW_INTERVIEW_DETAILS_SUCCESS";
export const VIEW_INTERVIEW_DETAILS_FAIL = "VIEW_INTERVIEW_DETAILS_FAIL";
export const VIEW_INTERVIEW_DETAILS_NETWORK_ERROR =
  "VIEW_INTERVIEW_DETAILS_NETWORK_ERROR";

// check interview time Brijesh

export const CHECK_INTERVIEW_TIME_INITIATE = "CHECK_INTERVIEW_TIME_INITIATE";
export const CHECK_INTERVIEW_TIME_SUCCESS = "CHECK_INTERVIEW_TIME_SUCCESS";
export const CHECK_INTERVIEW_TIME_FAIL = "CHECK_INTERVIEW_TIME_FAIL";
export const CHECK_INTERVIEW_TIME_NETWORK_ERROR =
  "CHECK_INTERVIEW_TIME_NETWORK_ERROR";

// Subscription Module by Abhishek Srivastava
export const GET_SUBSCRITPTION_STATUS = "GET_SUBSCRITPTION_STATUS";
export const GET_SUBSCRITPTION_STATUS_ERROR = "GET_SUBSCRITPTION_STATUS_ERROR";
export const GET_SUBSCRITPTION_PLAN_DETAILS = "GET_SUBSCRITPTION_PLAN_DETAILS";
export const GET_SUBSCRITPTION_PLAN_DETAILS_ERROR =
  "GET_SUBSCRITPTION_PLAN_DETAILS_ERROR";
export const ADD_SUBSCRITPTION_PLAN_DETAILS = "ADD_SUBSCRITPTION_PLAN_DETAILS";
export const ADD_SUBSCRITPTION_PLAN_DETAILS_ERROR =
  "ADD_SUBSCRITPTION_PLAN_DETAILS_ERROR";
export const CANCEL_SUBSCRITPTION_PLAN = "CANCEL_SUBSCRITPTION_PLAN";
export const CANCEL_SUBSCRITPTION_PLAN_ERROR =
  "CANCEL_SUBSCRITPTION_PLAN_ERROR";
export const RESET_CANCEL_SUBSCRIPTION_STATUS =
  "RESET_CANCEL_SUBSCRIPTION_STATUS";

// get paymentInvoicelist for employer
export const GET_EMPLOYER_PAYMENT_INVOICE_LIST_INITIATE =
  "GET_EMPLOYER_PAYMENT_INVOICE_LIST_INITIATE";
export const GET_EMPLOYER_PAYMENT_INVOICE_LIST_SUCCESS =
  "GET_EMPLOYER_PAYMENT_INVOICE_LIST_SUCCESS";
export const GET_EMPLOYER_PAYMENT_INVOICE_LIST_FAIL =
  "GET_EMPLOYER_PAYMENT_INVOICE_LIST_FAIL";
export const GET_EMPLOYER_PAYMENT_INVOICE_LIST_NETWORK_ERROR =
  "GET_EMPLOYER_PAYMENT_INVOICE_LIST_NETWORK_ERROR";

// generate invoice
export const GETNERATE_INVOICE_INITIATE = "GETNERATE_INVOICE_INITIATE";
export const GETNERATE_INVOICE_SUCCESS = "GETNERATE_INVOICE_SUCCESS";
export const GETNERATE_INVOICE_FAIL = "GETNERATE_INVOICE_FAIL";
export const GETNERATE_INVOICE_NETWORK_ERROR =
  "GETNERATE_INVOICE_NETWORK_ERROR";

// get payment preview
export const GET_PAYMENT_PREVIEW_INITIATE = "GET_PAYMENT_PREVIEW_INITIATE";
export const GET_PAYMENT_PREVIEW_SUCCESS = "GET_PAYMENT_PREVIEW_SUCCESS";
export const GET_PAYMENT_PREVIEW_FAIL = "GET_PAYMENT_PREVIEW_FAIL";
export const GET_PAYMENT_PREVIEW_NETWORK_ERROR =
  "GET_PAYMENT_PREVIEW_NETWORK_ERROR";

// make invoice payment
export const MAKE_INVOICE_PAYMENT_INITIATE = "MAKE_INVOICE_PAYMENT_INITIATE";
export const MAKE_INVOICE_PAYMENT_SUCCESS = "MAKE_INVOICE_PAYMENT_SUCCESS";
export const MAKE_INVOICE_PAYMENT_FAIL = "MAKE_INVOICE_PAYMENT_FAIL";
export const MAKE_INVOICE_PAYMENT_NETWORK_ERROR =
  "MAKE_INVOICE_PAYMENT_NETWORK_ERROR";

export const CLEAR_GENERATE_INVOICE = "CLEAR_GENERATE_INVOICE";
//get time slot brijesh
export const GET_INTERVIEWER_TIME_SLOTS_INITIAL =
  "GET_INTERVIEWER_TIME_SLOTS_INITIAL";
export const GET_INTERVIEWER_TIME_SLOTS_SUCCESS =
  "GET_INTERVIEWER_TIME_SLOTS_SUCCESS";
export const GET_INTERVIEWER_TIME_SLOTS_FAIL =
  "GET_INTERVIEWER_TIME_SLOTS_FAIL";
export const GET_INTERVIEWER_TIME_SLOTS_NETWORK_ERROR =
  "GET_INTERVIEWER_TIME_SLOTS_NETWORK_ERROR";

//update profile data
export const UPDATED_MOBILE_INITIAL = "UPDATED_MOBILE_INITIAL";
export const UPDATED_MOBILE_SUCCESS = "UPDATED_MOBILE_SUCCESS";
export const UPDATED_MOBILE_FAIL = "UPDATED_MOBILE_FAIL";

export const UPDATED_OTP_INITIAL = "UPDATED_OTP_INITIAL";
export const UPDATED_OTP_SUCCESS = "UPDATED_OTP_SUCCESS";
export const UPDATED_OTP_FAIL = "UPDATED_OTP_FAIL";

export const UPDATED_NAME_INITIAL = "UPDATED_NAME_INITIAL";
export const UPDATED_NAME_SUCCESS = "UPDATED_NAME_SUCCESS";
export const UPDATED_NAME_FAIL = "UPDATED_NAME_FAIL";

export const RESET_VERIFY_STATE = "RESET_VERIFY_STATE";

export const RESET_SIGNUP_STATE = "RESET_SIGNUP_STATE";

export const OTP_UPDATED_RESET = "OTP_UPDATED_RESET";

//export const RESET_OTP_UPDATED_STATE = 'RESET_OTP_UPDATED_STATE'

//credit balance
export const CREDIT_BALANCE_INITIAL = "CREDIT_BALANCE_INITIAL";
export const CREDIT_BALANCE_SUCCESS = "CREDIT_BALANCE_SUCCESS";
export const CREDIT_BALANCE_FAIL = "CREDIT_BALANCE_FAIL";

//HELP
export const HELP_AND_FEEDBACK_INITIATE = "HELP_AND_FEEDBACK_INITIATE";
export const HELP_AND_FEEDBACK_SUCCESS = "HELP_AND_FEEDBACK_SUCCESS";
export const HELP_AND_FEEDBACK_FAIL = "HELP_AND_FEEDBACK_FAIL";
export const HELP_AND_FEEDBACK_NETWORKERROR = "HELP_AND_FEEDBACK_NETWORKERROR";
export const HELP_AND_FEEDBACK_CLEAR = "HELP_AND_FEEDBACK_CLEAR";

//interviewer
export const SAVE_FILTER_VALUE = "SAVE_FILTER_VALUE";
export const SAVE_FILTER_VALUE_BY_TIME_SLOT = "SAVE_FILTER_VALUE_BY_TIME_SLOT";
export const SAVE_FILTER_VALUE_BY_NAME = "SAVE_FILTER_VALUE_BY_NAME";
export const CLEAR_ALL_SAVED_FILTER_AT_INTERVIEWER =
  "CLEAR_ALL_SAVED_FILTER_AT_INTERVIEWER";

export const CLEAR_SCHEDULE_INTERVIEW_STATE = "CLEAR_SCHEDULE_INTERVIEW_STATE";
